import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import innovators from "../../../assets/Innovator.png";
export default function RegisterNow() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  return (
    <div
      id="register-container"
      style={{
        width: "100%",
        minHeight: "280px",
        height: isMobile ? "200px" : isTablet ? "400px" : "500px",
        backgroundColor: "#173C7D9E",
        position: "relative",
        overflow: "hidden",
        padding: isMobile ? "5px" : "20px",
        boxSizing: "border-box",
      }}
    >
      {/* Video Background */}
      <video
        autoPlay
        muted
        loop
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
          pointerEvents: "none",
        }}
      >
        <source src="https://dbqa318yoj3nn.cloudfront.net/skillspherevediobg.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Text Positioned at Bottom */}
      <div
        style={{
          position: "absolute",
          bottom: isMobile ? "10px" : "20px",
          width: "100%",
          textAlign: "center",
          zIndex: 1,
          color: "#fff",
          fontFamily: "Montserrat, sans-serif",
          fontWeight: "bold",
          fontSize: isMobile ? "18px" : "35px",
          textShadow: "2px 2px 5px rgba(0, 0, 0, 0.5)",
        }}
      >
        NEXTGEN <span style={{ display: "block", color: "#9D75FF" ,display: "flex", justifyContent: "center"}}><img src={innovators} alt="innovators" className='w-[130px] md:w-[230px] justify-center'/></span>
      </div>
    </div>
  );
}
